import React from "react";
import "@/App.css";
import Hero from "@/components/sections/Hero";
import SocialSection from "@/components/sections/SocialSection";
import ProblemSection from "@/components/sections/ProblemSection";
import BenefitsSection from "@/components/sections/BenefitsSection";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import WhyMTLSection from "@/components/sections/WhyMTLSection";
import FAQSection from "@/components/sections/FAQSection";
import Footer from "@/components/sections/Footer";
import NotificationPopup from "@/components/NotificationPopup";

function App() {
    return (
        <div
            data-testid="mtl-landing-page"
            className="min-h-screen bg-white text-gray-900 font-sans antialiased"
        >
            <Hero />
            <SocialSection />
            <ProblemSection />
            <BenefitsSection />
            <TestimonialsSection />
            <WhyMTLSection />
            <FAQSection />
            <Footer />
            <NotificationPopup />
        </div>
    );
}

export default App;
